import type { Profile } from '~entities/user';
import { apiClient } from '~shared/api';

type LoginParams = {
  username: string;
  password: string;
  groupName: string;
};

export const postLogin = ({
  groupName,
  username,
  password,
}: LoginParams): Promise<Profile> =>
  apiClient.post<Profile>(
    `/api/${groupName}/login`,
    { username, password },
    { groupId: groupName }
  );

export const postLogout = (group: string): Promise<void> =>
  apiClient.post<void>(`/api/${group}/logout`, null, { groupId: group });

export const postAskResetPassword = ({
  group,
  email,
}: {
  group: string;
  email: string;
}): Promise<void> =>
  apiClient.post<void>(
    `/api/${group}/passwordChange`,
    { email },
    { groupId: group }
  );

export const postResetPassword = ({
  token,
  password,
  group,
}: {
  token: string;
  password: string;
  group: string;
}): Promise<void> =>
  apiClient.post<void>(
    `/api/${group}/resetPassword`,
    { token, password },
    { groupId: group }
  );
